import { addDays, endOfDay, startOfDay } from 'date-fns';
import { useETSTicketsQueryParams } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { getNow, getTodayStart } from 'gcs-common/helper/dateHelper';
import { useMemo } from 'react';
import Select, { type StylesConfig } from 'react-select';
import styles from './styles.module.scss';

interface OptionType {
  label: string;
  value: {
    startDate: string;
    endDate: string;
  };
}

const DateFilter = () => {
  const { etsTicketsfilters, setETSTicketsQueryParams } = useETSTicketsQueryParams();

  const handleChange = (daterange: OptionType['value'] | undefined) => {
    setETSTicketsQueryParams({
      startDate: daterange ? daterange.startDate : undefined,
      endDate: daterange ? daterange.endDate : undefined,
    });
  };

  const options = useMemo(
    () => [
      {
        label: 'Heute',
        value: {
          startDate: getTodayStart().toISOString(),
          endDate: endOfDay(getNow()).toISOString(),
        },
      },
      {
        label: 'Gestern',
        value: {
          startDate: startOfDay(addDays(getTodayStart(), -1)).toISOString(),
          endDate: endOfDay(getTodayStart()).toISOString(),
        },
      },
      {
        label: 'Letzte 7 Tage',
        value: {
          startDate: startOfDay(addDays(getNow(), -7)).toISOString(),
          endDate: endOfDay(getNow()).toISOString(),
        },
      },
      {
        label: 'Letzte 30 Tage',
        value: {
          startDate: startOfDay(addDays(getNow(), -30)).toISOString(),
          endDate: endOfDay(getNow()).toISOString(),
        },
      },
      {
        label: 'Letzte 90 Tage',
        value: {
          startDate: startOfDay(addDays(getNow(), -90)).toISOString(),
          endDate: endOfDay(getNow()).toISOString(),
        },
      },
      {
        label: 'Letztes Jahr',
        value: {
          startDate: startOfDay(addDays(getNow(), -365)).toISOString(),
          endDate: endOfDay(getNow()).toISOString(),
        },
      },
    ],
    [],
  );

  const customStyles: StylesConfig<OptionType> = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: '8px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
    }),
  };

  const defaultValue =
    etsTicketsfilters.startDate && etsTicketsfilters.endDate
      ? options.find(
          (x) => x.value.startDate === etsTicketsfilters.startDate && x.value.endDate === etsTicketsfilters.endDate,
        )
      : undefined;

  return (
    <div className={styles.dateSelectContainer}>
      <Select<OptionType>
        defaultValue={defaultValue}
        options={options}
        isClearable
        onChange={(selectedOption) => handleChange(selectedOption?.value)}
        styles={customStyles}
        placeholder="Datum"
      />
    </div>
  );
};

export default DateFilter;
